module.exports = __webpack_public_path__ + "static/img/source1.8f638ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/en/source1.jpg
// module id = WChy
// module chunks = 1